@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

.statusFilterWrapper {
  height: 56px;
  border-radius: 16px;
  padding:  0 16px;
  background-color: v.$palette-white;
  box-shadow: v.$shadow-2;
}

.statusFilterList {
  display: flex;
  flex-direction: row;
  gap: 24px;
  height: 100%;
  align-items: center;
  overflow-x: auto;
  @include c.hide-scrollbar;
}

.statusFilterButton {
  @include t.text(14px, 22px, 600);
  color: v.$palette-gray-900;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 12px 0;
  white-space: nowrap;

  &.active {
    color: v.$palette-blue;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: v.$palette-blue;
      border-radius: 3px;
      bottom: -4px;
      left: 0;
    }
  }

  .statusFilterCount {
    color: v.$palette-gray-600;
  }
}
